import { createFileRoute, Outlet, useLocation, useNavigate } from '@tanstack/react-router'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { Cafe } from '@/shared/assets/icons/Cafe'
import { LinkIcon } from '@/shared/assets/icons/LinkIcon'
import { PERMISSION_SUB_MODULES } from '@/shared/const'
import { PageWrapper } from '@/shared/ui/page-wrapper'
import { PermissionGuard } from '@/shared/ui/permission-guard'
import { CustomTab } from '@/shared/ui/tab'
import { CustomTabs } from '@/shared/ui/tabs'

type RouteName = 'list' | 'connects'

const BASE_PATH = '/administration/reference-books/canteens'

const getTabFromPath = (pathname: string): RouteName => {
  if (pathname.includes(`${BASE_PATH}/connects`)) return 'connects'
  return 'list'
}

export const Route = createFileRoute('/_auth/administration/reference-books/canteens')({
  staticData: {
    meta: {
      title: 'Столовые',
      description: '',
    },
  },
  component: RouteComponent,
})

function RouteComponent() {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const location = useLocation()

  const tab = getTabFromPath(location.pathname)

  useEffect(() => {
    if (location.pathname === BASE_PATH || location.pathname === `${BASE_PATH}/`) {
      navigate({ to: `${BASE_PATH}/list`, replace: true })
    }
  }, [location.pathname, navigate])

  const handleTabChange = (value: RouteName) => {
    navigate({ to: `${BASE_PATH}/${value}` })
  }

  return (
    <PermissionGuard permission={PERMISSION_SUB_MODULES.CANTEENS}>
      <PageWrapper title={t('Столовые')}>
        <CustomTabs value={tab} onChange={(_, value) => handleTabChange(value)}>
          <CustomTab
            value="list"
            icon={<Cafe />}
            iconPosition="start"
            label={t('Список столовых')}
          />
          <CustomTab
            value="connects"
            icon={<LinkIcon />}
            iconPosition="start"
            label={t('Связи школа - столовая')}
          />
        </CustomTabs>
        <Outlet />
      </PageWrapper>
    </PermissionGuard>
  )
}
